export const BackendCodesEnum = {
  // General codes | In request error { code, message, status }
  NotFound: 1001,
  BadRequest: 1002,

  // Unknown Code Group
  NoSuchBot: 10_001,
  UnknownSetting: 10_002,
};
